import PayPalButtonComponent from '@wix/thunderbolt-elements/src/components/PayPalButton/viewer/PayPalButton';
import PayPalButtonController from '@wix/thunderbolt-elements/src/components/PayPalButton/viewer/PayPalButton.controller';


const PayPalButton = {
  component: PayPalButtonComponent,
  controller: PayPalButtonController
};


export const components = {
  ['PayPalButton']: PayPalButton
};

